import { I18N } from "./I18N.js"
import { Menu } from "./Menu.js"
import { AppContext } from "./AppContext.js"
import { AboutUs } from "./AboutUs.js"
import { CookieConsent } from "./CookieConsent.js"
import { Login } from "./Login.js"
import { Counter } from "./Counter.js"
import { Stores } from "./Stores.js"
import { Logout } from "./Logout.js"
import { AccountInfo } from "./AccountInfo.js"
import { UserInfo } from "./UserInfo.js"
import { SoundsService } from "./lib/SoundsService.js"
import { WakeLockService } from "./lib/WakeLockService.js"
import { WindowsAgentAuthBridge } from "./lib/WindowsAgentAuthBridge.js"
import { WindowsAgentSoundReadyBridge } from "./lib/WindowsAgentSoundReadyBridge.js"

class App {
	_target
	_appContext
	_menu
	_stores
	_login
	_logout
	_aboutUs
	_counter
	_accountInfo
	_userInfo
	_sounds
	_wakeLock
	_windowsAgentAuthBridge
	_windowsAgentSoundReadyBridge

	constructor(targetId) {
		this._target = document.getElementById(targetId)
		this._target.innerHTML = `
			<div id="menu" class="card"></div>
			<div id="appOrders" class="flexHorizontal">
				<div id="counter" class="card"></div>
				<div id="aboutUs" class="card"></div>
				<div id="userInfo"></div>
			</div>
			<div id="toaster"></div>
		`
		I18N.translateElement(this._target)
	}

	init = () => {
		new CookieConsent()
		this._wakeLock = new WakeLockService()
		this._aboutUs = new AboutUs('aboutUs')

		this._appContext = new AppContext()
		this._menu = new Menu('menu', this._appContext)
		this._sounds = new SoundsService()
		this._stores = new Stores()
		this._stores.fetchStores()
			.then(stores => {
				this._windowsAgentSoundReadyBridge = new WindowsAgentSoundReadyBridge()
				this._counter = new Counter('counter', stores, this._sounds, this._windowsAgentSoundReadyBridge)
				this._windowsAgentAuthBridge = new WindowsAgentAuthBridge(stores)
				this._login = new Login('login')
				this._login.setAppContext(this._appContext)
				this._login.addOnLoginHandlers(
					this._counter.subscribeToStoreCounterEvents,
					this._counter.fetchOrders,
					this._windowsAgentAuthBridge.start,
					() => this._appContext.setOpen('counter', true),
					() => this._appContext.setActive('counter')
				)
				this._login.addOnLogoutHandlers(
					this._counter.unSubscribeToStoreCounterEvents,
					this._windowsAgentAuthBridge.stop,
					() => this._appContext.setOpen('counter', false),
					() => this._appContext.setActive('aboutUs')
				)
				this._login.init()
				this._logout = new Logout(this._login)
				this._accountInfo = new AccountInfo(this._login)
				this._userInfo = new UserInfo('userInfo', this._login, this._counter)
				this._appContext.setMenu(this._menu)
				this._appContext.setComponents('aboutUs', [this._aboutUs])
				this._appContext.setComponents('counter', [this._counter])
				this._appContext.setComponents('login', [this._login])
				this._appContext.setComponents('logout', [this._logout, this._aboutUs])
				this._appContext.setComponents('keycloakAccount', [this._accountInfo])
				this._appContext.setComponents('userInfo', [this._userInfo])
				this._appContext.restore()
		
				/*window.onbeforeunload = () => {
					this._counter.unSubscribeToStoreCounterEvents()
				}*/
			})
	}
}

export default App
